import * as React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import EmailSettingsCard from './EmailSettingsCard';

const settingsCardSx = {
  backgroundColor: 'grey.900',
  borderRadius: 3,
};

export default function NotificationSettingsSection() {
  return (
    <Stack spacing={3} sx={{ pb: 2 }}>
      <Box sx={settingsCardSx}>
        <EmailSettingsCard />
      </Box>
    </Stack>
  );
}
